export default __webpack_public_path__ + "static/jackson-david-unsplash-e7dca500f548ba0e7de8e0e2e8ef29f5.png";